// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"625":"imagePhotoswipe","712":"shared"}[chunkId] + "." + {"625":"230767ea","712":"ebc3137f"}[chunkId] + ".css";
};